import SuspenseLoading from '@components/commons/SuspenseLoading';
import { AuthLayout, HomeLayout } from '@components/layouts';
import {
  Account,
  ApiKeyList,
  ApplicationList,
  ChangePassword,
  Login,
  AccountInfo,
  DbList,
  UserIdDetail,
  DbDetail,
  LocationList,
  UserIdList,
} from '@components/pages';
import { useAppSelector } from '@hooks';
import { Routes } from '@utils/constants';
import { FC, Suspense } from 'react';
import { Routes as BrowserRoutes, Navigate, Route } from 'react-router-dom';

const publicRoutes: IAppRoute[] = [
  {
    path: Routes.LOGIN,
    element: Login,
  },
  {
    path: Routes.CHANGE_PASSWORD,
    element: ChangePassword,
  },
];

const privateRoutes: IAppRoute[] = [
  {
    path: Routes.ACCOUNT,
    element: Account,
  },
  {
    path: Routes.ACCOUNT_INFO,
    element: AccountInfo,
  },
  {
    path: Routes.APPLICATION_LIST,
    element: ApplicationList,
  },
  {
    path: Routes.DB_LIST,
    element: DbList,
  },
  {
    path: Routes.DB_DETAIL,
    element: DbDetail,
  },
  {
    path: Routes.API_KEY_LIST,
    element: ApiKeyList,
  },
  {
    path: Routes.LOCATION_LIST,
    element: LocationList,
  },
  {
    path: Routes.USER_ID_DETAIL,
    element: UserIdDetail,
  },
  {
    path: Routes.USER_ID_LIST,
    element: UserIdList,
  },
];

const AppRoutes: FC = () => {
  const { user } = useAppSelector((state) => state.auth);
  return (
    <BrowserRoutes>
      {!user ? (
        <Route element={<AuthLayout />}>
          {publicRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <Suspense fallback={<SuspenseLoading />}>
                  <route.element />
                </Suspense>
              }
            />
          ))}
          <Route
            path="*"
            element={<Navigate to={Routes.LOGIN} replace={true} />}
          />
        </Route>
      ) : (
        <Route element={<HomeLayout />}>
          {privateRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <Suspense fallback={<SuspenseLoading />}>
                  <route.element />
                </Suspense>
              }
            />
          ))}
          <Route
            path="*"
            element={<Navigate to={Routes.APPLICATION_LIST} replace={true} />}
          />
        </Route>
      )}
    </BrowserRoutes>
  );
};

export default AppRoutes;
